import { render, staticRenderFns } from "./video_config.vue?vue&type=template&id=b761776e&scoped=true&"
import script from "./video_config.vue?vue&type=script&lang=js&"
export * from "./video_config.vue?vue&type=script&lang=js&"
import style0 from "./video_config.vue?vue&type=style&index=0&id=b761776e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b761776e",
  null
  
)

export default component.exports